import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar, Divider } from '@mui/material';
// mock
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Scrollbar from './../../components/scrollbar';
import NavSection from './../../components/nav-section';

import './index.css';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// ----------------------------------------------------------------------

// const NAV_WIDTH = 240;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ 
  openNav, onCloseNav, auth, navConfig, isCreateOrderPage, handleNavigation, collapseNavbar, 
  handleHover, isNavCollapse, navWidth }) {
  const { pathname } = useLocation();

  const [collapseButton, setCollapseButton] = useState(false);
  const [isNavSectionScroll , setIsNavSectionScroll] = useState(false);

  const isDesktop = useResponsive('up', 'md');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("beforeunload", handleNavigation);

    return () => {
      window.removeEventListener("beforeunload", handleNavigation);
    };
  }, [isCreateOrderPage]);


  const renderContent = (
    <Scrollbar
      sx={{
        maxHeight: 2200,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
      onMouseEnter={() => setCollapseButton(true)}
      onMouseLeave={() => setCollapseButton(false)}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', width: '100%', justifyContent: 'center' }}>
        { !isNavCollapse && 
          <img style={{width: '100px'}} src='/assets/haus-logo.png' alt="Depo24" />
        }
      </Box>

      {
        isNavCollapse &&
        <Box sx={{ px: 2.5, py: 1.5, display: 'inline-flex', width: '100%', justifyContent: 'center' }}></Box>
      }

      {
        !isNavCollapse &&
        <Box sx={{ mb: 2, mx: 2.5 }}>
          <Link underline="none">
            <StyledAccount>
              <Avatar src={account.photoURL} alt="photoURL" />

              <Box sx={{ ml: 2 }}>
                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                  {auth.user.name}
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-all' }}>
                  {auth?.user?.role}
                </Typography>
              </Box>
            </StyledAccount>
          </Link>
        </Box>
      }
      <Divider />

      <NavSection
        data={navConfig}
        handleNavigation={handleNavigation}
        handleHover={handleHover}
        isNavCollapse={isNavCollapse}
        isNavSectionScroll ={isNavSectionScroll}
        setIsNavSectionScroll = {setIsNavSectionScroll}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: navWidth },
      }}
    >
      {
        collapseButton
        && <div
          className={'collapser ' + (isNavCollapse && 'collapser-collapsed')}
          onMouseEnter={() => setCollapseButton(true)}
          onMouseLeave={() => setCollapseButton(false)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={collapseNavbar}>{isNavCollapse ? <ArrowForwardIosIcon fontSize="7px" /> : <ArrowBackIosNewIcon fontSize="7px" />}</div>
      }
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: navWidth,
              bgcolor: 'background.default',
              border: 'none',
              boxSizing:"border-box",
              boxShadow: '0px 1px 16px -5px grey',
              transition: 'all 0.3s ease-in-out'
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: navWidth },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
